import * as React from 'react';
import styles from './styles.scss';

const Owner = props => {
  const { attributes } = props.owner;

  const image = attributes.find(attr => attr.type === 'image');
  const name = attributes.find(attr => attr.name.toLowerCase().includes('name'));
  const tile1 = attributes.find(attr => attr.name.toLowerCase().includes('tile 1'));
  const tile2 = attributes.find(attr => attr.name.toLowerCase().includes('tile 2'));
  const company = attributes.find(attr => attr.name.toLowerCase().includes('company'));

  return (
    <React.Fragment>
      <div className="owner">
        <div className="img-cover">
          <img src={image ? image.value : null} alt={name ? name.value : null} />
        </div>
        <div className="owner-caption">
          <div className="caption-left">
            <div className="owner-name">{name ? name.value : null}</div>
            <div className="owner-position">{tile1 ? tile1.value : null}</div>
          </div>
          <div className="caption-right">
            <div className="owner-tile">{tile2 ? tile2.value : null}</div>
            <div className="owner-company">{company ? company.value : null}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Owner;



// WEBPACK FOOTER //
// ./src/pages/AboutUs/Owner.js